module.exports = __webpack_public_path__ + "96df88179ef7422352ee02accb7404b8.png";